"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.memo = function (func) {
    var cache = {};
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var key = JSON.stringify(args);
        if (key in cache) {
            return cache[key];
        }
        var value = func.apply(void 0, args);
        cache[key] = value;
        return value;
    };
};
//# sourceMappingURL=memo.js.map